export const ROLE = {
  EDITOR: 'Editor',
  LOC_EDITOR: 'LOCEditor',
};

export const ROLES = [
  {
    label: 'Editor',
    value: ROLE.EDITOR,
  },
  {
    label: 'LOC Editor',
    value: ROLE.LOC_EDITOR,
  },
];
